import { EventType } from './EventType';
import { startup, launchCourse } from './handlers';
import { EventSystem } from '../utils/eventSystem';

export const Events = new EventSystem();

// Add the default event listeners.
Events.addEventListener( EventType.STARTUP, startup );
Events.addEventListener( EventType.LAUNCH_COURSE, launchCourse );
